import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { FlowChartButtonBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonBuilder'
import { FlowChartButtonStatsBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonStatsBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import {
  ButtonConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import {
  ButtonAppearance,
  FlowChartButton,
} from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import EntityType from 'common/builder/constants/EntityType'
import { getOTNButtonCaption } from 'common/builder/selectors/builder/buttonSelectors'

export const NotificationRequestButtonGenericConverterRule: ConverterRule<
  IButton,
  FlowChartButton,
  ButtonConverterRulePayload
> = {
  predicate: (entity: IButton) =>
    entity?.entity === EntityType.BUTTON &&
    'isNotificationRequest' in entity &&
    entity?.isNotificationRequest === true,

  convert: (entity, { state, builderId, fields }): FlowChartButton | null => {
    const otnCaption = getOTNButtonCaption(state, builderId, entity.id)
    const { users = 0, clicks = 0, segmentId = null } = entity?.stats || {}

    return new FlowChartButtonBuilder(entity.id)
      .withCaption(replaceFieldsInString(otnCaption || entity.caption, fields))
      .withAppearance(ButtonAppearance.DEFAULT_CENTERED)
      .withStats(
        new FlowChartButtonStatsBuilder()
          .withUsers(users)
          .withClicks(clicks)
          .withSegmentId(segmentId)
          .build(),
      )
      .withIsInteractive(true)
      .withNextStep(new FlowChartNextStepBuilder(entity.id).build())
      .build()
  },
}
